import { Spin } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { MainLayout } from '../../../components/Layout';

import { doGetProfile } from '../stores/thunk';
import { useFeatureFlags } from '../../feature-flags/feature-flags.hook';

const Container = ({ component: Comp, activeTab, allowedRoles, allowedFeatureFlag, ...rest }) => {
  //const { component: Comp } = props;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const error = useSelector((state) => state.common.error);
  const { featureFlags } = useFeatureFlags();

  const allowedByFeatureFlag = useMemo(
    () => !allowedFeatureFlag || (featureFlags && !!featureFlags[allowedFeatureFlag]),
    [featureFlags, allowedFeatureFlag],
  );

  useEffect(() => {
    if (auth && !auth.user) {
      dispatch(doGetProfile());
    }
  }, [auth.user]);
  // this is because auth.isFetching is becomeing false twice, first time it only has .authenticated
  if (auth && auth.authenticated === undefined) {
    return <></>;
  }

  if (auth && (auth.authenticated === false || error?.statusCode === 401)) {
    return <Redirect to={{ pathname: '/logout', state: { from: location.pathname } }} />;
  }

  if (auth && auth.authenticated && auth.user && !featureFlags) {
    return <Spin style={{ paddingTop: 100, width: '100%' }} />;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        const restrictedPaths = ['/riders', '/vehicles', '/routes'];
        const isRestrictedPath = restrictedPaths.some((path) => props.location.pathname.includes(path));

        if (auth && auth.authenticated) {
          if (isRestrictedPath) {
            return <Redirect to={{ pathname: `/home` }} />;
          } else if (allowedByFeatureFlag && allowedRoles.includes(auth?.user?.role)) {
            return (
              Comp && (
                <MainLayout {...rest}>
                  <Comp activeTab={activeTab} {...props} />
                </MainLayout>
              )
            );
          } else {
            return <Redirect to={{ pathname: `/home` }} />;
          }
        } else {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }
      }}
    />
  );
};

export default Container;
